<p-confirmDialog></p-confirmDialog>

<div class="card">
  <!-- Kanban pins the stats row + filters and scrolls only the board below;
       the table view keeps p-table's own scrolling. -->
  <div class="card-content"
       [class.card-content--fixed-header]="viewMode === 'kanban'">

    <!-- ============ Stats cards ============ -->
    <div class="stats-cards-row stats-cards-row--nowrap" *ngIf="!loading">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value" *ngIf="hasRates">
            <span class="cur">≈ USD</span> {{ formatMoney(usdPipeline) }}
          </span>
          <span class="stats-card-value" *ngIf="!hasRates">—</span>
          <span class="stats-card-label">Active Pipeline</span>
          <span class="stats-card-sublabel">
            Open deals (excl. Won / Lost)
            <ng-container *ngIf="unratedDealCount > 0"> · {{ unratedDealCount }} unrated excluded</ng-container>
          </span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-briefcase"></i></div>
      </div>

      <div class="stats-card stats-card--info">
        <div class="stats-card-main">
          <span class="stats-card-value" *ngIf="hasRates">
            <span class="cur">≈ USD</span> {{ formatMoney(usdWeighted) }}
          </span>
          <span class="stats-card-value" *ngIf="!hasRates">—</span>
          <span class="stats-card-label">Weighted Value</span>
          <span class="stats-card-sublabel">Revenue × Winning %</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-chart-bar"></i></div>
      </div>

      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value" *ngIf="hasRates">
            <span class="cur">≈ USD</span> {{ formatMoney(usdAvgDealSize) }}
          </span>
          <span class="stats-card-value" *ngIf="!hasRates">—</span>
          <span class="stats-card-label">Avg Deal Size</span>
          <span class="stats-card-sublabel">Across open deals</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-dollar"></i></div>
      </div>

      <div class="stats-card stats-card--info">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ closingThisMonthCount }}</span>
          <span class="stats-card-label">Closing This Month</span>
          <span class="stats-card-sublabel">By expected close date</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-calendar"></i></div>
      </div>

      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ winRatePct }}%</span>
          <span class="stats-card-label">Win Rate</span>
          <span class="stats-card-sublabel">{{ wonCount }} won of {{ wonCount + lostCount }} closed</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-percentage"></i></div>
      </div>
    </div>

    <!-- ============ Collapsible filter bar (driven by header filter icon) ============ -->
    <div class="filter-bar filter-bar-collapsible mb-4"
         [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible"
         *ngIf="!loading">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label class="filter-label">Status</label>
          <p-select [(ngModel)]="selectedStatus" (ngModelChange)="applyFilters()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value"
            placeholder="All" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Stage</label>
          <p-select [(ngModel)]="selectedStage" (ngModelChange)="applyFilters()"
            [options]="stageOptions" optionLabel="label" optionValue="value"
            placeholder="All stages" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Progress</label>
          <p-select [(ngModel)]="selectedProgress" (ngModelChange)="applyFilters()"
            [options]="progressOptions" optionLabel="label" optionValue="value"
            placeholder="All progress" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Presales PM</label>
          <p-select [(ngModel)]="selectedPMId" (ngModelChange)="applyFilters()"
            [options]="projectManagers" optionLabel="name" optionValue="id"
            placeholder="All PMs" [showClear]="true" [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Presales Client</label>
          <p-select [(ngModel)]="selectedClientId" (ngModelChange)="applyFilters()"
            [options]="clients" optionLabel="name" optionValue="id"
            placeholder="All clients" [showClear]="true" [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Sales Owner</label>
          <p-select [(ngModel)]="selectedAccountManagerId" (ngModelChange)="applyFilters()"
            [options]="accountManagers" optionLabel="name" optionValue="id"
            placeholder="All sales owners" [showClear]="true" [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Service Group</label>
          <p-select [(ngModel)]="selectedServiceGroupId" (ngModelChange)="applyFilters()"
            [options]="serviceGroups" optionLabel="name" optionValue="id"
            placeholder="All groups" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions">
        <button type="button" *ngIf="hasActiveFilters()" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
        <button type="button"
                class="view-toggle-icon"
                [class.active]="viewMode === 'kanban'"
                (click)="setViewMode(viewMode === 'kanban' ? 'table' : 'kanban')"
                [pTooltip]="viewMode === 'kanban' ? 'Switch to Table view' : 'Switch to Kanban view'"
                tooltipPosition="top">
          <i class="pi pi-th-large"></i>
        </button>
      </div>
    </div>

    <!-- ============ TABLE VIEW ============ -->
    <p-table
      *ngIf="viewMode === 'table'"
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredProjects"
      [loading]="loading"
      [paginator]="filteredProjects.length > 15"
      [alwaysShowPaginator]="false"
      [rows]="15"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} presales projects"
      [tableStyle]="{ 'min-width': '100%' }"
      [resizableColumns]="true"
      columnResizeMode="expand"
      styleClass="p-datatable no-column-lines resize-handles-visible presales-inventory-table">

      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn pSortableColumn="projectCode" style="width: 80px;">Code <p-sortIcon field="projectCode" /></th>
          <th pResizableColumn pSortableColumn="name" style="width: 160px;">Project <p-sortIcon field="name" /></th>
          <th pResizableColumn pSortableColumn="presalesClientName" style="width: 150px;">Presales Client <p-sortIcon field="presalesClientName" /></th>
          <th pResizableColumn pSortableColumn="managerName" style="width: 150px;">Presales PM <p-sortIcon field="managerName" /></th>
          <th pResizableColumn pSortableColumn="accountManagerName" style="width: 160px;">Sales Owner <p-sortIcon field="accountManagerName" /></th>
          <th pResizableColumn pSortableColumn="serviceGroupName" style="width: 150px;">Service Group <p-sortIcon field="serviceGroupName" /></th>
          <th pResizableColumn pSortableColumn="salesStage" style="width: 100px;">Stage <p-sortIcon field="salesStage" /></th>
          <th pResizableColumn pSortableColumn="progress" style="width: 110px;">Progress <p-sortIcon field="progress" /></th>
          <!-- Revenue and Winning % are deliberately not table columns. Both remain visible on the
               kanban cards, the KPI cards above the table, the edit dialog and the Excel export. -->
          <!-- Actions is pinned right (position: sticky), which conflicts with the
               resize handle's positioning — deliberately neither sortable nor resizable. -->
          <th class="th-actions sticky-actions-col" style="width: 130px;">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-project>
        <tr [class.row-won]="project.salesStage === 'Won'"
            [class.row-inactive]="project.isActive === false"
            [class.row-clickable]="canManage"
            (click)="canManage && showEditDialog(project)">
          <td>
            <span class="code-cell">{{ project.projectCode || '—' }}</span>
          </td>
          <td>
            <div class="name-cell">
              <span class="n-primary" [pTooltip]="project.name" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ project.name }}</span>
            </div>
          </td>
          <td [pTooltip]="project.presalesClientName" [tooltipDisabled]="!project.presalesClientName" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ project.presalesClientName || '—' }}</td>
          <td [pTooltip]="project.managerName" [tooltipDisabled]="!project.managerName" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ project.managerName || '—' }}</td>
          <td [pTooltip]="project.accountManagerName" [tooltipDisabled]="!project.accountManagerName" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ project.accountManagerName || '—' }}</td>
          <td [pTooltip]="project.serviceGroupName" [tooltipDisabled]="!project.serviceGroupName" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">{{ project.serviceGroupName || '—' }}</td>
          <td>
            <p-tag [value]="project.salesStage" [severity]="stageSeverity(project.salesStage)" style="font-size: 0.7rem;" />
          </td>
          <td>
            <p-tag *ngIf="project.progress" [value]="progressLabel(project.progress)"
                   [severity]="progressSeverity(project.progress)" style="font-size: 0.7rem;" />
            <span *ngIf="!project.progress">—</span>
          </td>
          <td class="table-cell-actions sticky-actions-col" (click)="$event.stopPropagation()">
            <div class="table-actions-stack">
              <!-- Promote to Delivery is disabled (promoteEnabled = false). The wizard and its
                   handlers are left in place so the feature can be restored by flipping that one
                   flag; nothing here is deleted. -->
              <p-button
                *ngIf="promoteEnabled && canManage && project.salesStage === 'Won' && !project.promotedToProjectId"
                icon="pi pi-send"
                [text]="true"
                severity="success"
                size="small"
                pTooltip="Promote to Delivery" tooltipPosition="top"
                (onClick)="openPromoteDialog(project)" />
              <!-- Wrapped in a span so the tooltip fires on the wrapper — disabled
                   PrimeNG buttons set pointer-events:none which suppresses hover
                   events on the button itself. -->
              <!-- No longer locked on promotedToProjectId: that column is stamped at pursuit
                   CREATION (it points at the twin project), so the lock disabled the toggle on
                   every row rather than only on promoted ones. With promotion disabled there is
                   nothing left for it to protect. -->
              <span *ngIf="canManage"
                    class="tooltip-wrap"
                    [pTooltip]="project.isActive ? 'Active — click to deactivate' : 'Inactive — click to activate'"
                    tooltipPosition="top">
                <p-button
                  [icon]="project.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                  [severity]="project.isActive ? 'success' : 'secondary'"
                  [text]="true"
                  size="small"
                  (onClick)="toggleActive(project)" />
              </span>
              <p-button
                *ngIf="canManage"
                icon="pi pi-pencil"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit" tooltipPosition="top"
                (onClick)="showEditDialog(project)" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="9" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No presales projects yet</p>
              <p class="empty-description">Click "Add Presales Project" in the header to add your first opportunity.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- ============ KANBAN VIEW (one column per progress state) ============ -->
    <!-- Columns are the working status a PM moves a pursuit through. Sales stage
         rides on the card (coloured left edge + badge). Mirrors the Details board. -->
    <div *ngIf="viewMode === 'kanban'" class="kanban-view kanban-view--progress">
      <div class="empty-state" *ngIf="visibleKanbanColumns.length === 0">
        <div class="empty-icon"><i class="pi pi-inbox"></i></div>
        <p class="empty-message">No deals match these filters</p>
        <p class="empty-description">Clear a filter, or untick "Hide empty columns" to see every progress state.</p>
      </div>

      <div class="kanban-scroll" *ngIf="visibleKanbanColumns.length > 0">
      <div class="kanban-grid">
        <div class="kanban-col" *ngFor="let col of visibleKanbanColumns"
             [ngClass]="col.cssClass"
             [class.is-empty]="col.projects.length === 0">
          <div class="kanban-col-head">
            <div class="kanban-col-head-top">
              <span class="kanban-col-title">
                <span class="dot" [ngClass]="col.cssClass"></span>{{ col.label }}
              </span>
              <span class="kanban-col-count">{{ col.projects.length }}</span>
            </div>
            <span class="kanban-col-sub" *ngIf="col.projects.length > 0 && columnUsdTotal(col) !== null">
              ≈ USD {{ formatMoney(columnUsdTotal(col)!) }}
            </span>
          </div>
          <div class="kanban-col-body">
            <div class="kanban-card kanban-card--rich"
                 *ngFor="let p of col.projects"
                 [ngClass]="stageClass(p.salesStage)"
                 [class.won]="p.salesStage === 'Won'"
                 [class.is-inactive]="p.isActive === false"
                 [class.is-overdue]="calcOverdueDays(p.endDate)"
                 (click)="canManage ? showEditDialog(p) : null">

              <div class="kanban-card-top">
                <span class="k-stage" [ngClass]="stageClass(p.salesStage)">{{ p.salesStage }}</span>
                <span class="k-rag" *ngIf="p.projectStatus"
                      [ngClass]="projectStatusBadgeClass(p.projectStatus)"
                      [pTooltip]="'Health: ' + p.projectStatus" tooltipPosition="top"></span>
              </div>

              <h4 class="kanban-card-title" [pTooltip]="p.name" tooltipPosition="top"
                  [tooltipOptions]="{ showDelay: 600 }">{{ p.name }}</h4>

              <div class="kanban-card-meta">
                <span class="k-client" [pTooltip]="p.presalesClientName || 'No client set'" tooltipPosition="top">
                  <i class="pi pi-building"></i>{{ p.presalesClientName || 'No client set' }}
                </span>
                <span class="k-code" *ngIf="p.projectCode">{{ p.projectCode }}</span>
              </div>

              <div class="kanban-card-value">
                <span class="k-money">
                  <span class="cur">{{ p.currency }}</span>{{ formatMoneyCompact(p.revenueTarget) }}
                </span>
                <span class="k-win" [class.k-win--high]="p.winningPercentage >= 70"
                      [pTooltip]="'Winning probability'" tooltipPosition="top">
                  <span class="k-win-bar"><span class="k-win-fill"
                        [style.width.%]="p.winningPercentage || 0"></span></span>
                  {{ p.winningPercentage || 0 }}%
                </span>
              </div>

              <!-- Comments preview, clamped to two lines; full text on hover. -->
              <div class="kanban-card-comments" *ngIf="p.comments"
                   [pTooltip]="p.comments" tooltipPosition="top" [tooltipOptions]="{ showDelay: 500 }">
                {{ p.comments }}
              </div>

              <div class="kanban-card-foot">
                <span class="k-owner" [pTooltip]="'PM: ' + (p.managerName || 'Unassigned')
                        + (p.accountManagerName ? ' · Sales: ' + p.accountManagerName : '')"
                      tooltipPosition="top">
                  <span class="k-avatar" [style.--k-hue]="avatarHue(p.managerName)">{{ initials(p.managerName) }}</span>
                  <span class="k-owner-name">{{ p.managerName || 'Unassigned' }}</span>
                </span>
                <span class="k-close k-overdue" *ngIf="calcOverdueDays(p.endDate) as od">
                  <i class="pi pi-exclamation-circle"></i>{{ od }}d over
                </span>
                <span class="k-close" *ngIf="!calcOverdueDays(p.endDate) && p.expectedCloseDate"
                      [class.k-close--soon]="isClosingSoon(p.expectedCloseDate)"
                      [pTooltip]="'Expected close: ' + formatDate(p.expectedCloseDate)" tooltipPosition="top">
                  <i class="pi pi-calendar"></i>{{ closeLabel(p.expectedCloseDate) }}
                </span>
              </div>
            </div>
            <div class="kanban-empty" *ngIf="col.projects.length === 0">No deals</div>
          </div>
        </div>
      </div>
      </div>
    </div>

  </div>
</div>


<!-- =========================================================
     ADD / EDIT PRESALES PROJECT dialog
     ========================================================= -->
<!-- #presalesFormDlg: dropdown panels attach to the DIALOG (see [appendTo] below),
     not to body. That lets a panel escape the scrolling content box without being
     clipped, while staying anchored inside the dialog — so the form can scroll and
     keep its footer reachable at the same time. -->
<p-dialog
  #presalesFormDlg
  [visible]="displayDialog"
  (visibleChange)="displayDialog = $event"
  [header]="isEditMode ? 'Edit Presales Project' : 'Add Presales Project'"
  [modal]="true"
  styleClass="dialog-lg presales-form-dialog"
  [dismissableMask]="!saveInFlight"
  [closable]="!saveInFlight">

  <div class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">

      <!-- =========== Presales-specific ============ -->
      <div class="emp-section-title"><i class="pi pi-briefcase"></i> Presales-specific fields</div>

      <div class="form-row two-columns">
        <div class="field" [class.field-invalid]="!!projectCodeError">
          <label for="code">Presales Project Code</label>
          <input pInputText id="code" [(ngModel)]="selectedProject.projectCode"
            (ngModelChange)="projectCodeError = null"
            placeholder="e.g., PS-0001" />
          <small class="field-error" *ngIf="projectCodeError">{{ projectCodeError }}</small>
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['name'] && !selectedProject.name.trim()">
          <label for="name">Presales Project Name <span class="required-star">*</span></label>
          <input pInputText id="name" [(ngModel)]="selectedProject.name"
            placeholder="Enter presales project name" (blur)="fieldTouched['name'] = true" />
          <small class="field-error" *ngIf="fieldTouched['name'] && !selectedProject.name.trim()">Project name is required</small>
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field" [class.field-invalid]="fieldTouched['managerId'] && !selectedProject.managerId">
          <label for="pm">Presales Project Manager <span class="required-star">*</span></label>
          <p-select id="pm" [(ngModel)]="selectedProject.managerId"
            [options]="projectManagers" optionLabel="name" optionValue="id"
            placeholder="Select PM" [filter]="true" filterPlaceholder="Search…"
            (onBlur)="fieldTouched['managerId'] = true" panelStyleClass="filter-dropdown-panel" [appendTo]="presalesFormDlg" />
          <small class="field-error" *ngIf="fieldTouched['managerId'] && !selectedProject.managerId">PM is required</small>
        </div>
        <div class="field">
          <label for="am">Sales Owner</label>
          <p-select id="am" [(ngModel)]="selectedProject.accountManagerId"
            [options]="accountManagers" optionLabel="name" optionValue="id"
            placeholder="Select sales owner" [showClear]="true" [filter]="true" filterPlaceholder="Search…" panelStyleClass="filter-dropdown-panel" [appendTo]="presalesFormDlg" />
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="client">Presales Client</label>
          <!-- Type-or-select: pick an existing presales client, or type a name that
               doesn't exist yet and it is created on save (see resolveClientThenSave).
               [forceSelection]="false" is what permits the new value;
               [showEmptyMessage]="false" stops a "No results found" panel appearing
               while the user is still typing that new name. -->
          <p-autocomplete id="client" [(ngModel)]="clientSearchText"
            [suggestions]="filteredClients" (completeMethod)="searchClient($event)"
            (onSelect)="onClientSelect($event)" (onClear)="onClientClear()"
            [dropdown]="true" optionLabel="name"
            [forceSelection]="false" [showClear]="true"
            [showEmptyMessage]="false" [completeOnFocus]="false"
            placeholder="Type or select client"
            styleClass="w-full" [style]="{ width: '100%' }"
            panelStyleClass="filter-dropdown-panel" [appendTo]="presalesFormDlg" />
          <small class="field-hint">Pick an existing client or type a new one — it's created when you save.</small>
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="revenue">Revenue Target</label>
          <div class="money-input-row">
            <p-inputNumber id="revenue" [(ngModel)]="selectedProject.revenueTarget"
              [min]="0" [minFractionDigits]="0" [maxFractionDigits]="2" placeholder="0.00" />
            <p-select [(ngModel)]="selectedProject.currency"
              [options]="currencyOptions" optionLabel="label" optionValue="value" panelStyleClass="filter-dropdown-panel" styleClass="currency-select" [appendTo]="presalesFormDlg" />
          </div>
        </div>
        <div class="field">
          <label for="winning">Winning Percentage</label>
          <p-inputNumber id="winning" [(ngModel)]="selectedProject.winningPercentage"
            [min]="0" [max]="100" [minFractionDigits]="0" [maxFractionDigits]="0" suffix=" %" />
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="stage">Sales Stage</label>
          <p-select id="stage" [(ngModel)]="selectedProject.salesStage"
            [options]="stageOptions" optionLabel="label" optionValue="value" panelStyleClass="filter-dropdown-panel" [appendTo]="presalesFormDlg" />
        </div>
        <div class="field">
          <label for="progress">Progress</label>
          <p-select id="progress" [(ngModel)]="selectedProject.progress"
            [options]="progressOptions" optionLabel="label" optionValue="value"
            placeholder="Not set" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" [appendTo]="presalesFormDlg" />
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="leadSource">Lead Source</label>
          <p-select id="leadSource" [(ngModel)]="selectedProject.leadSource"
            [options]="leadSourceOptions" optionLabel="label" optionValue="value"
            placeholder="How did we find this lead?" [showClear]="true"
            panelStyleClass="presales-lead-source-panel" [appendTo]="presalesFormDlg" />
        </div>
      </div>

      <!-- Lost reason only visible when stage = Lost. Required in that case so
           we always capture WHY the deal was lost — critical for win-loss reporting. -->
      <div class="form-row" *ngIf="selectedProject.salesStage === 'Lost'">
        <div class="field" [class.field-invalid]="fieldTouched['lostReason'] && !selectedProject.lostReason?.trim()">
          <label for="lostReason">Lost Reason <span class="required-star">*</span></label>
          <textarea id="lostReason" [(ngModel)]="selectedProject.lostReason" [rows]="2"
            placeholder="Why did we lose this deal? (e.g., pricing, competitor, no budget)"
            (blur)="fieldTouched['lostReason'] = true"></textarea>
          <small class="field-error" *ngIf="fieldTouched['lostReason'] && !selectedProject.lostReason?.trim()">Please explain why the deal was lost</small>
        </div>
      </div>

      <!-- =========== System fields ============ -->
      <div class="emp-section-title"><i class="pi pi-cog"></i> System fields</div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="sg">Service Group</label>
          <p-select id="sg" [(ngModel)]="selectedProject.serviceGroupId"
            [options]="serviceGroups" optionLabel="name" optionValue="id"
            placeholder="Select service group" [showClear]="true" [filter]="true" filterPlaceholder="Search…" panelStyleClass="filter-dropdown-panel" [appendTo]="presalesFormDlg" />
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['costCenterId'] && !selectedProject.costCenterId">
          <label for="cc">Cost Center <span class="required-star">*</span></label>
          <p-select id="cc" [(ngModel)]="selectedProject.costCenterId"
            [options]="costCentersForClient" optionLabel="name" optionValue="id"
            placeholder="Select cost center" [showClear]="true" [filter]="true" filterPlaceholder="Search…" panelStyleClass="filter-dropdown-panel" [appendTo]="presalesFormDlg"
            emptyMessage="No cost centers available — add a shared one, or one for this client"
            emptyFilterMessage="No match in this list — a client-specific cost center only appears once that client is selected above"
            (onChange)="fieldTouched['costCenterId'] = true" />
          <!-- The list is filtered to shared cost centers + the selected client's own. Without
               this hint an absent cost center reads as a loading failure rather than a filter. -->
          <small class="field-hint" *ngIf="!selectedProject.presalesClientId">
            Showing shared cost centers only. Select a Presales Client to also see theirs.
          </small>
          <small class="field-error" *ngIf="fieldTouched['costCenterId'] && !selectedProject.costCenterId">Cost center is required</small>
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="description">Description</label>
          <textarea id="description" [(ngModel)]="selectedProject.description" [rows]="2"
            placeholder="Full project description"></textarea>
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="scope">Scope Summary</label>
          <textarea id="scope" [(ngModel)]="selectedProject.scopeSummary" [rows]="2"
            placeholder="One-liner scope"></textarea>
        </div>
        <div class="field">
          <label for="competitor">Competitor</label>
          <input pInputText id="competitor" [(ngModel)]="selectedProject.competitor" placeholder="Whom we are competing against" />
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="comments">Comments</label>
          <textarea id="comments" [(ngModel)]="selectedProject.comments" [rows]="2"
            placeholder="Running commentary / notes"></textarea>
        </div>
      </div>

      <div class="form-row three-columns">
        <div class="field">
          <label for="startDate">Start Date</label>
          <p-datePicker id="startDate" [(ngModel)]="formStartDate" dateFormat="D, M d, yy" appendTo="body" [showIcon]="true" [showClear]="true" />
        </div>
        <div class="field">
          <label for="endDate">End Date</label>
          <p-datePicker id="endDate" [(ngModel)]="formEndDate" dateFormat="D, M d, yy" appendTo="body" [showIcon]="true" [showClear]="true" />
        </div>
        <div class="field">
          <label for="expectedClose">Expected Close</label>
          <p-datePicker id="expectedClose" [(ngModel)]="formExpectedClose" dateFormat="D, M d, yy" appendTo="body" [showIcon]="true" [showClear]="true" />
        </div>
      </div>

      <div class="form-row" *ngIf="isEditMode">
        <div class="field">
          <div class="checkbox-item">
            <p-checkbox [(ngModel)]="selectedProject.isActive" [binary]="true" inputId="isActive" />
            <label for="isActive" class="checkbox-label">Active — include in filters and dashboards</label>
          </div>
        </div>
      </div>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()" severity="secondary" [outlined]="true" [disabled]="saveInFlight" />
      <p-button label="Save Project" icon="pi pi-check" (onClick)="saveProject()" severity="primary" [loading]="saveInFlight" [disabled]="saveInFlight" />
    </div>
  </ng-template>
</p-dialog>


<!-- =========================================================
     PROMOTE-TO-DELIVERY wizard — compact 3-step popup.
     Opens from the row's Promote button or after a Won stage-change.

     DISABLED: gated on promoteEnabled, which is false. Kept rather than deleted so the
     feature can be restored by flipping that single flag.
     ========================================================= -->
<p-dialog
  *ngIf="promoteEnabled"
  [visible]="displayPromoteDialog"
  (visibleChange)="displayPromoteDialog = $event"
  header="Promote to Delivery"
  [modal]="true"
  styleClass="dialog-sm promote-wizard-dialog"
  [dismissableMask]="!promoteInFlight"
  [closable]="!promoteInFlight">

  <div class="promote-wiz" *ngIf="promoteTarget">
    <!-- Compact deal banner -->
    <div class="promote-wiz-deal">
      <i class="pi pi-send"></i>
      <div class="promote-wiz-deal-info">
        <span class="promote-wiz-deal-title">{{ promoteTarget.name }}</span>
        <span class="promote-wiz-deal-sub" *ngIf="promoteTarget.presalesClientName">{{ promoteTarget.presalesClientName }}</span>
        <span class="promote-wiz-deal-sub text-warn" *ngIf="!promoteTarget.presalesClientName">No presales client linked</span>
      </div>
    </div>

    <!-- Step indicator (1 → 2 → 3) -->
    <ol class="promote-wiz-steps">
      <ng-container *ngFor="let s of promoteSteps; let last = last">
        <li class="promote-wiz-step"
            [class.active]="promoteStep === s.n"
            [class.done]="promoteStep > s.n">
          <span class="promote-wiz-step-dot">
            <i class="pi pi-check" *ngIf="promoteStep > s.n"></i>
            <span *ngIf="promoteStep <= s.n">{{ s.n }}</span>
          </span>
          <span class="promote-wiz-step-label">{{ s.title }}</span>
        </li>
        <li class="promote-wiz-connector" *ngIf="!last" [class.done]="promoteStep > s.n"></li>
      </ng-container>
    </ol>

    <!-- Step panels — only the current step is shown -->
    <div class="promote-wiz-body">
      <!-- ==================== STEP 1: Client ==================== -->
      <div *ngIf="promoteStep === 1" class="promote-wiz-panel">
        <p class="promote-wiz-hint">
          Only the client <strong>Name</strong> and <strong>Description</strong> move — no other presales fields.
        </p>

        <div class="promote-wiz-choices">
          <label class="promote-wiz-choice"
                 [class.selected]="promoteMode === 'create'"
                 [class.disabled]="!promoteTarget.presalesClientName">
            <input type="radio" name="promoteMode" [(ngModel)]="promoteMode" value="create"
                   [disabled]="!promoteTarget.presalesClientName" />
            <div>
              <div class="promote-wiz-choice-title"><i class="pi pi-plus-circle"></i> Create new Client</div>
              <div class="promote-wiz-choice-desc">
                From "<strong>{{ promoteTarget.presalesClientName || '—' }}</strong>"
              </div>
            </div>
          </label>

          <label class="promote-wiz-choice" [class.selected]="promoteMode === 'link'">
            <input type="radio" name="promoteMode" [(ngModel)]="promoteMode" value="link" />
            <div>
              <div class="promote-wiz-choice-title"><i class="pi pi-link"></i> Link existing</div>
              <div class="promote-wiz-choice-desc">Pick from main Clients</div>
            </div>
          </label>
        </div>

        <div class="promote-wiz-existing" *ngIf="promoteMode === 'link'">
          <label>Existing Client <span class="required-star">*</span></label>
          <p-select [(ngModel)]="promoteExistingClientId"
            [options]="mainClients" optionLabel="name" optionValue="id"
            placeholder="Select from main Clients"
            [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>

      <!-- ==================== STEP 2: Delivery Project details ==================== -->
      <div *ngIf="promoteStep === 2" class="promote-wiz-panel">
        <p class="promote-wiz-hint">Both are optional — leave blank to reuse the presales name.</p>

        <div class="field">
          <label>Delivery Project Name</label>
          <input pInputText [(ngModel)]="promoteProjectNameOverride"
            [placeholder]="promoteTarget.name" />
        </div>
        <div class="field">
          <label>Delivery Project Code</label>
          <input pInputText [(ngModel)]="promoteProjectCodeOverride"
            placeholder="e.g., BID-03454" />
          <small class="field-hint">Different from the presales code ({{ promoteTarget.projectCode || '—' }}).</small>
        </div>
      </div>

      <!-- ==================== STEP 3: Review ==================== -->
      <div *ngIf="promoteStep === 3" class="promote-wiz-panel">
        <p class="promote-wiz-hint">Here's what will happen when you click Promote.</p>

        <ul class="promote-wiz-review">
          <li>
            <i class="pi pi-check"></i>
            <span *ngIf="promoteMode === 'create'">
              New Client <strong>{{ promoteTarget.presalesClientName }}</strong> in main Clients
            </span>
            <span *ngIf="promoteMode === 'link'">
              Linked to <strong>{{ getMainClientName(promoteExistingClientId) }}</strong>
            </span>
          </li>
          <li>
            <i class="pi pi-check"></i>
            New delivery Project <strong>{{ promoteProjectNameOverride.trim() || promoteTarget.name }}</strong>
            <span *ngIf="promoteProjectCodeOverride.trim()"> ({{ promoteProjectCodeOverride.trim() }})</span>
          </li>
          <li>
            <i class="pi pi-check"></i>
            This presales row marked <strong>Promoted</strong>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="promote-wiz-footer">
      <p-button *ngIf="promoteStep > 1"
        label="Back" icon="pi pi-arrow-left"
        (onClick)="backPromoteStep()"
        severity="secondary" [outlined]="true" [disabled]="promoteInFlight" />
      <p-button *ngIf="promoteStep === 1 || promoteStep === 2"
        label="Cancel" icon="pi pi-times"
        (onClick)="hidePromoteDialog()"
        severity="secondary" [text]="true" [disabled]="promoteInFlight"
        styleClass="promote-wiz-cancel" />
      <span class="promote-wiz-footer-spacer"></span>
      <p-button *ngIf="promoteStep < 3"
        label="Next" icon="pi pi-arrow-right" iconPos="right"
        (onClick)="nextPromoteStep()"
        severity="primary" [disabled]="!canGoNextPromoteStep()" />
      <p-button *ngIf="promoteStep === 3"
        label="Promote" icon="pi pi-send" severity="success"
        [loading]="promoteInFlight"
        [disabled]="!canConfirmPromote()"
        (onClick)="confirmPromote()" />
    </div>
  </ng-template>
</p-dialog>
